import { GridValidRowModel, GridValueFormatter } from '@mui/x-data-grid-pro';
import { DateFormatPreset, formatDate } from '@procureai/ui-mui';
import { isNil } from 'ramda';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../DataGridCustom.types';

type DateFormatterValue = Union.Nullable<Date | string>;

interface DateFormatterFactoryOptions {
  preset: DateFormatPreset;
}

export const dateFormatterFactory = <R extends GridValidRowModel = any>(
  options: DateFormatterFactoryOptions,
): GridValueFormatter<R> => {
  return (value: DateFormatterValue) => {
    try {
      return !isNil(value) ? formatDate(options.preset, new Date(value)) : NULLISH_CELL_VALUE;
    } catch (e) {
      console.log(e);
    }
    return NULLISH_CELL_VALUE;
  };
};
